import * as React from 'react';
import styled from '@emotion/styled';

import { Stylable } from '~/types';
import { fluidRange, breakpoints, dimensions, css } from '~/styles';

const StyledWrapper = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: ${breakpoints.max}px;
  margin: 0 auto;
  position: relative;

  ${(p) =>
    p.fullheight
      ? css`
          height: 100%;
        `
      : null};

  ${fluidRange(
    'paddingLeft',
    `${dimensions.containerPadding.min}px`,
    `${dimensions.containerPadding.max}px`
  )}
  ${fluidRange(
    'paddingRight',
    `${dimensions.containerPadding.min}px`,
    `${dimensions.containerPadding.max}px`
  )}
`;

interface StylesProps {
  fullheight?: boolean;
  bottomTextPadding?: boolean;
}
interface Props extends Stylable, StylesProps {}
const Wrapper: React.FC<Props> = ({ fullheight, children, className }) => (
  <StyledWrapper className={className} fullheight={fullheight}>
    {children}
  </StyledWrapper>
);

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/layout/Wrapper.tsx